import { t } from '@lingui/core/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { StepperStep } from 'noddi-ui-web';
import { customerTimelineWheelPickups, getCarDisplayName } from 'noddi-util';
import { getWheelPickupDescription } from './wheelPickupStep';

/**
 * Signing documents are optional; the latest physical attempt for each car owns its timeline.
 */
export const getTirePickupStep = ({
  booking,
  key
}: {
  booking: Pick<BookingRecordDetailsCustomer, 'connectedWheelPickups'>;
  key: string;
}): StepperStep | null => {
  const pickups = customerTimelineWheelPickups(booking);
  if (pickups.length === 0) {
    return null;
  }

  return {
    label: t`Tire pickup`,
    key,
    content: (
      <div className='flex flex-col gap-3'>
        {pickups.map((pickup) => (
          <div key={`${pickup.booking.id}-${pickup.car.id}`} className='text-sm text-muted-foreground'>
            <p className='font-medium'>{getCarDisplayName({ car: pickup.car })}</p>
            <p>{getWheelPickupDescription(pickup)}</p>
          </div>
        ))}
      </div>
    )
  };
};
